import { Action } from "../../../processes/models/Action/Action";
import { addHistoryAction } from "../../reducers/ui/actions/actions";
import { getActionHistory } from "../../reducers/ui/selectors/actionHistorySelectors";
import { setDataHistory, setDataUI } from "../../reducers/ui/uiReducer";
import { getUIState } from "../../reducers/ui/uiSelectors";
import { AppStore } from "../../store";

export const undoHandler = (store: AppStore) => {
  const state = store.getState();
  const actionHistory = getActionHistory(state);
  const action = actionHistory.pop();

  if (action) {
    store.dispatch(setDataHistory({ dataHistory: actionHistory.serialize() }));
    if (action.data) store.dispatch(setDataUI(action.undo()));
  }
};

export const redoHandler = (store: AppStore) => {
  const state = store.getState();
  const actionHistory = getActionHistory(state);
  const action = actionHistory.getRedo();

  if (action) {
    actionHistory.push(action);
    store.dispatch(setDataHistory({ dataHistory: actionHistory.serialize() }));
    if (action.data) store.dispatch(setDataUI(action.redo()));
  }
};

export const addDataHistoryHandler =
  (beforeData: any, afterData: any) => (store: AppStore) => {
    const state = store.getState();
    const actionHistory = getActionHistory(state);

    actionHistory.push(
      Action.fromJSON({
        before: beforeData,
        after: afterData,
      })
    );

    const serializedDataHistory = actionHistory.serialize();

    store.dispatch(
      setDataHistory({
        dataHistory: serializedDataHistory,
      })
    );
  };

export const addActionToHistoryHandler =
  (beforeState: any, afterState: any) => (store: AppStore) => {
    const stateUIBefore = getUIState(beforeState);
    const stateUIAfter = getUIState(afterState);
    store.dispatch(
      addHistoryAction({
        before: stateUIBefore,
        after: stateUIAfter,
      })
    );
  };
